import {
	APP_MODE,
	AUTH_BYPASS_ACCESS_TOKEN,
	AUTH_BYPASS_REQUESTED,
} from "@/constants/constants";

/**
 * Local-only escape hatch that skips the Okta sign-in flow. Enable it with
 * `VITE_APP_AUTH_BYPASS=true` in `.env.localdev`, which is gitignored. The mode
 * check keeps it inert in a deployed build even if the variable leaks into a
 * staging/preprod/production environment.
 */
export const AUTH_BYPASS =
	["localdev", "localtilt"].includes(APP_MODE) && AUTH_BYPASS_REQUESTED;

/** Stand-in for the Okta profile the rest of the app reads. */
export const BYPASS_USER = {
	email: "local.dev@mozn.ai",
	name: "Local Dev",
	sub: "local-dev",
};

/**
 * Optional real bearer token, so requests against the staging API still
 * succeed while the sign-in flow is skipped.
 */
export const BYPASS_TOKEN = AUTH_BYPASS ? AUTH_BYPASS_ACCESS_TOKEN : "";
